"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_END_OF_THE_DAY = exports.DEFAULT_START_OF_THE_DAY = exports.MEETING_PLACE_PLACEHOLDERS = exports.MEETING_PLACE_OPTIONS = exports.MEETING_LIMIT_OPTIONS = exports.minutesInHour = exports.minutesInDay = exports.MEETING_FREQUENCY_OPTIONS = exports.MEETING_DURATION_OPTIONS = exports.MEETING_BUSY_OPTIONS = void 0;

var _momentTimezone = _interopRequireDefault(require("moment-timezone"));

var MEETING_BUSY_OPTIONS = [{
  id: 'true',
  name: 'Yes, do not allow recipients to book over existing meetings in my calendar.'
}, {
  id: 'false',
  name: 'No, allow recipients to book over existing meetings in my calendar'
}];
exports.MEETING_BUSY_OPTIONS = MEETING_BUSY_OPTIONS;
var MEETING_DURATION_OPTIONS = [{
  id: 15,
  name: '15 minutes'
}, {
  id: 30,
  name: '30 minutes'
}, {
  id: 45,
  name: '45 minutes'
}, {
  id: 60,
  name: '1 hour'
}];
exports.MEETING_DURATION_OPTIONS = MEETING_DURATION_OPTIONS;
var MEETING_FREQUENCY_OPTIONS = [{
  id: 15,
  name: '15 minutes'
}, {
  id: 30,
  name: '30 minutes'
}, {
  id: 45,
  name: '45 minutes'
}, {
  id: 60,
  name: '1 hour'
}];
exports.MEETING_FREQUENCY_OPTIONS = MEETING_FREQUENCY_OPTIONS;
var minutesInDay = 24 * 60;
exports.minutesInDay = minutesInDay;
var minutesInHour = 60;
exports.minutesInHour = minutesInHour;
var MEETING_LIMIT_OPTIONS = [{
  name: '15 days',
  id: minutesInDay * 15
}, {
  name: '30 days',
  id: minutesInDay * 30
}, {
  name: '45 days',
  id: minutesInDay * 45
}, {
  name: '60 days',
  id: minutesInDay * 60
}, {
  name: '90 days',
  id: minutesInDay * 90
}];
exports.MEETING_LIMIT_OPTIONS = MEETING_LIMIT_OPTIONS;
var MEETING_PLACE_OPTIONS = [{
  name: 'Phone Call',
  id: 'phone_call'
}, {
  name: 'In Person',
  id: 'in_person'
}, {
  name: 'Video Conference',
  id: 'video_conference'
}];
exports.MEETING_PLACE_OPTIONS = MEETING_PLACE_OPTIONS;
var MEETING_PLACE_PLACEHOLDERS = {
  phone_call: 'Type phone number',
  in_person: 'Type address',
  video_conference: 'Type link'
};
exports.MEETING_PLACE_PLACEHOLDERS = MEETING_PLACE_PLACEHOLDERS;
var DEFAULT_START_OF_THE_DAY = (0, _momentTimezone.default)().set({
  hour: 9,
  minutes: 0,
  seconds: 0
});
exports.DEFAULT_START_OF_THE_DAY = DEFAULT_START_OF_THE_DAY;
var DEFAULT_END_OF_THE_DAY = (0, _momentTimezone.default)().set({
  hour: 17,
  minutes: 0,
  seconds: 0
});
exports.DEFAULT_END_OF_THE_DAY = DEFAULT_END_OF_THE_DAY;